export function throttle(fn) {
    var requestId = null;
    var lastArgs;
    var later = function (context) { return function () {
        requestId = null;
        fn.apply(context, lastArgs);
    }; };
    var throttled = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        lastArgs = args;
        if (requestId === null) {
            requestId = requestAnimationFrame(later(this));
        }
    };
    throttled.cancel = function () {
        cancelAnimationFrame(requestId);
        requestId = null;
    };
    return throttled;
}
